import { Box, Button, Stack, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { isNotEmpty, makeTxtOverFLow } from '../utils/format'
import { getFileUrl } from '../services/s3-service';
import { useAuthContext } from '../context/AuthContext';
import { useQuery } from 'react-query';
import QueryKey from '../utils/QueryKey';
import BlurImg from './BlurImg';

function ComCard1({ i, handleClick }) {
    const { setLoadingScreen } = useAuthContext();
    const { isLoading: isImgLoading, data: imgUrl } = useQuery([QueryKey.img, i?.logo],
        () => getFileUrl({ fileKey: i?.logo }), {
        enabled: isNotEmpty(i?.logo),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    useEffect(() => {
        setLoadingScreen(isImgLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isImgLoading]);



    return (
        <Button sx={{ border: 1, boxShadow: 1, borderRadius: 4, borderColor: "rgba(0,0,0,0.1)", height: 180, width: 180 }} onClick={() => handleClick(i)}>
            <Tooltip title={i?.catName}>
                <Stack direction={"column"} alignItems="center">
                    <Box sx={{
                        width: 120, height: 120, borderRadius: 4, my: 1, display: 'flex', justifyContent: 'center',
                        alignItems: 'center', overflow: 'hidden', // Ensure content doesn't overflow the box
                    }}>
                        <BlurImg imgUrl={imgUrl} alt={"Category"} />
                    </Box>
                    <Tooltip title={i?.comName}>
                    <Typography sx={{ fontSize: 14, fontWeight: 500, mt: 0.5, color: "rgba(0,0,0, 1)" }} >{makeTxtOverFLow(i?.comName, 15)}</Typography>
                    </Tooltip>
                </Stack>
            </Tooltip>
        </Button>
    )
}

export default ComCard1